import React from 'react';
import { SectionContainer } from '../../ticketForm/components/SectionContainer';
import { SectionBody } from '../../ticketForm/components/SectionBody';
import { SectionLine } from '../../ticketForm/components/SectionLine';
import { FormikPremiumInput } from '../../ui/inputs/customInput';
import SectionTitle from '../../ticketForm/components/SectionTitle';
import { Half } from '../../ticketForm/components/Half';
import SpecialLabelText from '../../ticketForm/components/SpecialLabelText';
import SpecialLabel from '../../ticketForm/components/SpecialLabel';
import { PriceSuggestion } from './priceSuggestion/PriceSuggestion';
import quoteService from 'modules/emergencies/quoteService';

export const QuoteQuoteSectionWithPriceSuggestion = ({ quoteFormBodyData }) => {
  const { showErrors, isEdit, isReadOnly, ticketDetail } = quoteFormBodyData;

  const canQuoteBeEditedAfterAcceptance =
    quoteService.bussiness.canQuoteBeEditedAfterAcceptance(ticketDetail);

  return (
    <SectionContainer>
      <SectionTitle>Quote</SectionTitle>
      <SectionBody>
        <SectionLine>
          <SpecialLabel>
            <SpecialLabelText>Price</SpecialLabelText>
          </SpecialLabel>
        </SectionLine>
        <SectionLine>
          <FormikPremiumInput
            label="Currency"
            showErrors={showErrors}
            name="price.currency"
            type={'select'}
            isRequired={true}
            isDisabled={!canQuoteBeEditedAfterAcceptance && (isEdit || isReadOnly)}
            width={'33%'}
            availableOptions={[
              {
                value: 'EUR',
                label: 'Euro',
              },
              {
                value: 'MAD',
                label: 'Dirham',
              },
            ]}
          />
          <PriceSuggestion quoteFormBodyData={quoteFormBodyData} />
          <FormikPremiumInput
            type={'number'}
            isRequired={true}
            label={'Base price'}
            isDisabled={!canQuoteBeEditedAfterAcceptance && (isEdit || isReadOnly)}
            showErrors={showErrors}
            name={`price.amount`}
            width={'33%'}
          />
        </SectionLine>
        {/* expiration */}
        <SectionLine>
          <Half>
            <SectionLine>
              <SpecialLabel>
                <SpecialLabelText>Expiration</SpecialLabelText>
              </SpecialLabel>
            </SectionLine>
            <SectionLine>
              <Half>
                <FormikPremiumInput
                  isDisabled={isReadOnly || isEdit}
                  label="Date"
                  name="expiration_date"
                  type="date"
                />
              </Half>
              <Half>
                <FormikPremiumInput
                  isDisabled={isReadOnly || isEdit}
                  label="Time"
                  name="expiration_time"
                  type="time"
                />
              </Half>
            </SectionLine>
          </Half>
        </SectionLine>
        {/* other conditions */}
        <SectionLine>
          <SpecialLabel>
            <SpecialLabelText>Other conditions</SpecialLabelText>
          </SpecialLabel>
        </SectionLine>
        <SectionLine>
          <FormikPremiumInput
            isDisabled={isReadOnly || isEdit}
            label="Quote conditions"
            name="conditions"
            type="text"
          />
        </SectionLine>
      </SectionBody>
    </SectionContainer>
  );
};
